import { select } from '@angular-redux/store';
import {
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    HostListener,
    Inject,
    Output,
    QueryList,
    Renderer2,
    ViewChild,
    ViewChildren
} from '@angular/core';
import { NgForm } from '@angular/forms';
import * as moment from 'moment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { IntegrationCompany, LicensePackageOptions, LicensePackageType, LicenseStatus } from "sharedFeatures/enums";
import { ItemData } from 'sharedFeatures/form';
import { infoPopUpComponent } from "sharedFeatures/infoPopUp";
import {
    AuthData,
    BrixxPlan, CommonApp, Company,
    CrunchCheckTokenResult, PlanTemplateType
} from "sharedFeatures/sharedModels";
import { NewPlanDataValues } from "sharedFeatures/sharedModels/newPlanDataValues";
import { PlanTemplateDto } from "sharedFeatures/sharedModels/planTemplateDto";
import { CrunchService, PlanService, ProfileService, RedirectService } from "sharedFeatures/sharedServices";
import { isSuccessResponse } from "sharedFeatures/sharedServices/Responses/plan.index";
import { StartTrialWin } from 'sharedFeatures/start-trial-win';
import { dialogCreationActions } from "sharedFeatures/store";
import { UpgradeWin } from "sharedFeatures/upgrade-win";
import { AuthUtils, CurrencyData, Utils } from "sharedFeatures/utils";
import { DateUtils } from 'sharedFeatures/utils/date-utils';
import { RedirectGlobalService } from "sharedGuiSmall/sharedServices/redirectGlobal.service";
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';
import { SharedGuiSmallModule } from '../../../../../sharedGuiSmall/sharedGuiSmall.module';
import { MinValuePipe } from '../../../../pipes/minvalue.pipe';
import { SafeHtmlPipe } from '../../../../pipes/safehtml.pipe';
import { ScrollComponent } from '../../scroll';
import { NewPlanFormBodyComponent } from '../newplan-body.component';
import { NewPlanInnerForm } from '../newplan-inner.form';
import { NewPlanForm } from '../newplan.form';
import { LoadingSpinnerService } from 'sharedGuiSmall/sharedServices/loadingSpinner.service';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'newplan-start-form-body',
    templateUrl: './newplan-start-form-body.component.html',
    styleUrls: ['./newplan-start-form-body.component.less'],
    standalone: true,
    imports: [SharedGuiSmallModule, infoPopUpComponent, MinValuePipe, SafeHtmlPipe, forwardRef(() => NewPlanFormBodyComponent), TranslateModule],
    providers: [PlanService]
})
export class NewPlanStartFormBodyComponent extends NewPlanInnerForm {

    planTemplateLogoText = $localize`SELECT_A_PLAN_TEMPLATE`;
    planNameLogoTextCrunchChosen = $localize`NAME_YOUR_PLAN`;
    planNameLogoText = $localize`SET_YOUR_PLAN_NAME`;
    planStartDateLogoTextCrunchChosen = $localize`FORECAST_START_DATE_AND`;
    planStartDateLogoText = $localize`PICK_YOUR_PLAN_START`;
    currencyLogoText = $localize`CHOOSE_A_CURRENCY`;
    taxSystemLogoTextCrunchChosen = $localize`TAX_SYSTEM`;
    taxSystemLogoText = $localize`SET_A_TAX_SYSTEM`;
    connectToCrunchButtonText = $localize`CONNECT_TO_CRUNCH`;
    createPlanButtonText = $localize`CREATE_YOUR_PLAN`;
    startPlanButtonText = $localize`START_YOUR_PLAN`;
    xeroStartButtonText = $localize`START_YOUR_PLAN_FROM`;
    xeroUpgradeButtonText = $localize`UPGRADE_TO_PROFESSIONAL_TO`;
    crunchButtonText = $localize`Start your plan from Crunch`;
    myBusinessPlanText = $localize`My Business Plan`;
    upgradeYourAccountText = $localize`Upgrade your account to gain access to this feature.`;
    upgradeText = $localize`Upgrade`;
    upgradeToAccessText = $localize`Upgrade to access`;
    offTaxText = $localize`OFF`;
    VATTaxText = $localize`VAT`;
    salesTaxText = $localize`SALES_TAX`;
    GSTTAXText = $localize`GST`;
    previous12MonthsText = $localize`Previous 12 months`;
    repeatLastMonthText = $localize`Repeat the last month`;
    blankEnterManuallyText = $localize`Blank - enter manually`;
    planText = $localize` plan`;
    blankText = $localize`blank`
    blankPlanText = $localize`Blank plan`;
    bikeShopPlanText = $localize`BIKE_SHOP`;
    standardBusinessTemplate = $localize`standard business template`;
    StandardBusinessTemplate = $localize`STANDARD_BUSINESS_TEMPLATE`;
    coffeeShopPlanText = $localize`COFFEE_SHOP`;
    consultingPlanText = $localize`CONSULTING`;
    eCommercePlanText = $localize`E_COMMERCE`;
    foodVanPlanText = $localize`FOOD_VAN`;
    gardeningPlanText = $localize`GARDENING`;
    manufacturingPlanText = $localize`MANUFACTURING`;
    photographyPlanText = $localize`PHOTOGRAPHY`;
    restaurantPlanText = $localize`RESTAURANT`;
    retailPlanText = $localize`RETAIL`;
    SAASPlanText = $localize`SAAS`;
    crunchPlanText = $localize`crunch`;
    planNameFieldMustBeCompleted = $localize`The "Plan Name" field must be completed`;

    crunchConnectionChecked = new BehaviorSubject(false);

    planTemplates: Array<ItemData> = [];
    yearEndMonth: string = "1";

    onOrOffByDefault: Array<ItemData> = [
        { id: 'off', value: this.offTaxText, disabled: false },
        { id: 'vat', value: this.VATTaxText, disabled: false },
        { id: 'salesTax', value: this.salesTaxText, disabled: false },
        { id: 'gst', value: this.GSTTAXText, disabled: false }
    ];
    
    isUseTemplate: boolean = true;
    isUseCompanyData: boolean = true;
    loadTemplatePromise?: Promise<void>;

    errorMessage: string = "";
    currencyItems: Array<ItemData> = [];

    currentMonthIndex: number;
    currencyString: string = "1";

    teamplatelogoImg = "standard-business-template";
    chosenTemplateName = this.StandardBusinessTemplate;
    template = PlanTemplateType;

    isPlanStartDateChanger: boolean = false;

    @ViewChild(NgForm)
    private form!: NgForm;

    @ViewChild('templatesBlock')
    private templatesBlock!: ElementRef;

    @ViewChild('planTemplateLogoBlock')
    private planTemplateLogoBlock!: ElementRef;

    @ViewChild('chosenTemplateBlock')
    private chosenTemplateBlock!: ElementRef;

    @ViewChild('switchTemplateBlock')
    private switchTemplateBlock!: ElementRef;

    @ViewChild('setupBlock')
    private setupBlock!: ElementRef;

    @ViewChild('chooseTemplateBlock')
    private chooseTemplateBlock!: ElementRef;

    @ViewChild('tableDiv')
    private tableDiv!: ElementRef;

    // Unsubscribe event
    private storeUnsubscribe = new Subject<void>();

    @select(['appData', 'appComponent'])
    readonly appComponent$!: Observable<any>;
    appComponent: any = undefined;

    @select(['accountAppData', 'accountAppComponent'])
    readonly accountAppComponent$!: Observable<any>;
    private accountAppComponent: any = undefined;

    isShowClose: boolean = true;
    isRenderForSignUp: boolean = false;

    @Output() parentCaller: EventEmitter<any> = new EventEmitter();
    @Output() newPlanCreatedCaller: EventEmitter<any> = new EventEmitter();

    comboItems: Array<ItemData> = [
        { id: 0, value: this.previous12MonthsText, disabled: false },
        { id: 1, value: this.repeatLastMonthText, disabled: false },
        { id: 2, value: this.blankEnterManuallyText, disabled: false }
    ];

    data: NewPlanDataValues = new NewPlanDataValues();

    @ViewChildren(infoPopUpComponent)
    infoPopupItems: QueryList<infoPopUpComponent> | undefined;

    isBrixxChosen: boolean = true;
    isXeroChosen: boolean = false;
    isCrunchChosen: boolean = false;
    isNewCrunchUserFlow: boolean = false;
    isCrunchConnectionActive: boolean = false;

    isUpgradeNeeded: boolean = false;
    isFreeLicense: boolean = false;
    isTemplateBlockActive: boolean = false;
    packageType: LicensePackageType = LicensePackageType.None;
    packageName = '';

    titleText: string = '';

    titleText2nd: string = '';
    buttonText: string = this.upgradeText;

    industryId: number = 0;

    b1Color = '#404a5f';
    b3Color = '#2b3648';
    g1Color = '#f7f9fa';

    isBusinessDoctors: boolean = false;

    constructor(        
        el: ElementRef,
        r: Renderer2,
        private planService: PlanService,
        private redirectGlobalService: RedirectGlobalService,
        private reDirectService: RedirectService,
        private profileService: ProfileService,
        private crunchService: CrunchService,
        //private appData: AppData,
        @Inject(forwardRef(() => NewPlanForm)) parent: NewPlanForm,
        private loadingSpinnerService: LoadingSpinnerService,
        private translate: TranslateService
    ) {
        super(el, r);
        dialogCreationActions.setNewPlanDialogOpen(true);
        this.parent = parent;

        const currentDate = new Date();
        this.currentMonthIndex = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();

        const isExtendMinPlanStartDate = AuthUtils.isBetaFeatureActive(this.parent.authData, 'ExtendMinPlanStartDate');
        const yearRange = isExtendMinPlanStartDate ? [-10, 11] : [-3, 11];
        for (let i = yearRange[0]; i < yearRange[1]; i++) {
            const year = currentYear + i;
            this.yearComboItems.push({ id: i, value: year.toString(), disabled: false });
        }

        this.newPlan = this.parent.newPlan;
        this.newPlan.planName = this.myBusinessPlanText;
        this.newPlan.aTemplateName = this.standardBusinessTemplate;

        this.parent.testId = 'newPlan';
        this.isRenderForSignUp = parent.renderForSignup;
        this.parent.isNeedEsc = this.isRenderForSignUp && !parent.isShowClose;

        this.isNewCrunchUserFlow = localStorage.getItem('isCrunchFlow') === 'true';

        CurrencyData.currencies.forEach((item) => {
            const iData = new ItemData();
            iData.disabled = false;
            iData.id = item[0];
            iData.value = item[1];

            this.currencyItems.push(iData);
        });
        this.isShowClose = parent.isShowClose && !parent.renderForSignup;

        this.isBusinessDoctors = (String)(window['isBusinessDoctors']).toLowerCase() === 'true';

        this.teamplatelogoImg = this.isBusinessDoctors ? "business-doctors-standard-business-template" : "standard-business-template";

        this.loadTranslations();
        this.translate.onLangChange.subscribe(() => {

            this.loadTranslations();

        });

    }

    public onGoOut(callback?: Function): void {

        this.setNewPlanData();
        if (callback) callback();

    }

    public getScrollPane(): ScrollComponent {
        throw new Error("Method not implemented.");
    }
    public saveClosePanePlaceEl(): Element {
        throw new Error("Method not implemented.");
    }

    public reload(callback: Function): void {}

    getForm(): NgForm {
        return this.form;
    }

    loadTemplates(): void {
        this.loadTemplatePromise = this.planService.LoadPlanTemplates().then((data: Array<PlanTemplateDto>) => {
            this.planTemplates = data.map(x => {
                return {
                    id: x.ID,
                    value: x.TemplateName,
                    disabled: false
                };
            });
        }).then(async () => {
            if (this.profileService.companyPromise) {
                await this.selectTemplateByIndustry();
            } else if (!this.accountAppComponent) {
                this.profileService.LoadCompany(this.newPlan.companyId.toString());
                if (this.profileService.companyPromise)
                    await this.selectTemplateByIndustry();
            }
        });
    }

    aVatText: string = 'off';
    ngAfterViewInit() {

        this.currencyString = this.parent.authData.lastCurrencyId.toString();
        let N = 0;
        let containsNumbers: boolean = false;

        for (let plan of this.parent.plans) {

            let planNameNewSymbols = plan.planname.replace(/\s/g, "").replace(/[0-9]/g, '');
            if (this.newPlan.planName.replace(/\s/g, "").indexOf(planNameNewSymbols) >= 0) {
                let i = plan.planname.match(/\d/g);

                if (this.newPlan.planName.replace(/\s/g, '').replace(/[0-9]/g, '').toLowerCase() == plan.planname.replace(/\s/g, '').replace(/[0-9]/g, '').toLowerCase()) {

                    if (i != null) {
                        containsNumbers = true;
                        let iString = i.join("");
                        let vNumber = parseInt(iString);
                        if (vNumber > N) {
                            N = vNumber;
                        }
                    } else {
                        if (N == 0) {
                            N++;
                        }
                    }

                }
            }
        }
        if (N > 0) {
            if (containsNumbers)
                N++;
            this.newPlan.planName = `${this.myBusinessPlanText} ` + N;
        }

        this.packageType = AuthUtils.getLicensePackageType(this.parent.authData.priceOptionCodes);
        this.packageName = LicensePackageOptions.get(this.packageType as string)!.OptionName;

        this.isFreeLicense = this.packageType === LicensePackageType.BrixxFree;

        if (this.isFreeLicense)
            this.aVatText == "off";
        else if (this.parent.authData.lastTaxSystem && this.onOrOffByDefault.some(x => x.id === this.parent.authData.lastTaxSystem))
            this.aVatText = this.parent.authData.lastTaxSystem;

        this.toggleBlankPlan(true);
        this.isUseCompanyData = false;

        this.loadTemplates();

        if (this.packageType === LicensePackageType.None || this.packageType === LicensePackageType.BrixxFree)
            this.isUpgradeNeeded = true;

        // let startD = moment({ y: parseInt(this.newPlan.planStartYear), M: this.newPlan.planStartMonth, d: 1 }).add(this.durationYear, 'years');

        this.checkCrunchConnection();

        if (this.isNewCrunchUserFlow) {
            let orgName = localStorage.getItem('org-name');
            if (orgName)
                this.newPlan.planName = localStorage.getItem('org-name') + this.planText;
        }

        this.isPlanStartDateChanger = AuthUtils.isBetaFeatureActive(this.parent.authData, 'PlanStartDateChanger') && this.packageType === LicensePackageType.BrixxSingle;

        if (this.parent.authData != null && !this.years.length) {
            this.years = this.parent.authData.planDurationYears;//.filter(x => !x.disabled);
            this.translate.get(['Year', 'Years']).subscribe((translations) => {

                const oneYearTextItem = this.years.find(item => item.id == 1);
                if (oneYearTextItem) {
                    oneYearTextItem.value = `${1} ${translations['Year']}`;
                }

                for (let i = 2; i <= 10; i++) {
                    const yearComboItemsTextItem = this.years.find(item => item.id == i);
                    if (yearComboItemsTextItem) {
                        yearComboItemsTextItem.value = `${i} ${translations['Years']}`;
                    }
                }
            });

            if (this.parent.authData.licenseStatus == "Trial" || this.parent.authData.level >= 2) {
                if (this.years.some(x => x.id == 3 && !x.disabled))
                    this.durationYear = "3";
            }
        }

        this.calcActualsStartDate();                
    }

    onStartPlanDataChange() {
        
        if (this.skipOnStartPlanDataChange)
            return;        
        
        this.calcActualsStartDate();
        
    }

    ngOnInit() {
        this.newPlan.aTemplateName = this.standardBusinessTemplate;

        // Subscribe on the redux store
        this.subscribeReduxStore();
    }

    canUpgrade(): boolean {
        const licensesPackageType = [LicensePackageType.BrixxSingle];

        let result = false;

        let authData: AuthData | undefined = this.parent.authData;

        if (!authData)
            return false;

        const packageType = AuthUtils.getLicensePackageType(authData.priceOptionCodes);
        const hasEverHadTrial = authData.HasEverHadTrial;

        if (authData.licenseStatus == LicenseStatus.Free) {
            this.titleText2nd = this.upgradeYourAccountText;
            this.buttonText = this.upgradeText;
        }

        if (authData.licenseStatus == LicenseStatus.Free)
            this.titleText = this.upgradeToAccessText;

        if (authData.licenseStatus == LicenseStatus.Trial || licensesPackageType.includes(packageType) || authData.licenseStatus == LicenseStatus.Free) {
            return true;
        }
        
        return result;
    }

    selectTemplateByIndustry() {
        return this.profileService.companyPromise?.then((data: string) => {
            if (data && !Utils.isNullOrEmpty(data)) {
                let selectedCompany = <Company>JSON.parse(data).data;
                this.industryId = selectedCompany.Industry_ID;
                switch (this.industryId) {
                    case 152: this.chooseTemplate(PlanTemplateType.CoffeeShop); break;
                    case 155:
                    case 43:
                    case 10:
                    case 80:
                    case 105: this.chooseTemplate(PlanTemplateType.Consulting); break;
                    case 156: this.chooseTemplate(PlanTemplateType.Ecommerce); break;
                    case 158: this.chooseTemplate(PlanTemplateType.Gardening); break;
                    case 159: this.chooseTemplate(PlanTemplateType.Manufacturing); break;
                    case 136: this.chooseTemplate(PlanTemplateType.Photography); break;
                    case 32: this.chooseTemplate(PlanTemplateType.Restaurant); break;
                    case 27: this.chooseTemplate(PlanTemplateType.Retail); break;
                    case 161: this.chooseTemplate(PlanTemplateType.SAAS); break;
                    default: this.chooseTemplate(PlanTemplateType.StandardBusinessTemplate); break;
                }
            }
        });
    }

    templateHover() {
        this.templatesBlock.nativeElement.style.opacity = '0.75';
        this.templatesBlock.nativeElement.style.backgroundColor = this.b1Color;
        this.chosenTemplateBlock.nativeElement.style.opacity = '1';
        this.chosenTemplateBlock.nativeElement.style.color = this.b3Color;
        this.switchTemplateBlock.nativeElement.style.display = 'block';
        this.switchTemplateBlock.nativeElement.style.opacity = '1';
        this.planTemplateLogoBlock.nativeElement.style.opacity = '0.25';
    }

    templateFocusout() {
        this.templatesBlock.nativeElement.style.opacity = '1';
        this.templatesBlock.nativeElement.style.backgroundColor = this.g1Color;
        this.chosenTemplateBlock.nativeElement.style.color = this.b1Color;
        this.switchTemplateBlock.nativeElement.style.display = 'none';
        this.planTemplateLogoBlock.nativeElement.style.opacity = '1';
    }

    switchTemplate() {
        this.loadTemplatePromise?.then(_ => {
            this.setupBlock.nativeElement.style.display = 'none';
            this.chooseTemplateBlock.nativeElement.style.display = 'flex';
            this.isTemplateBlockActive = true;
            if (!this.parent.renderForSignup)
                this.r.setStyle(this.parent.getElDom(), 'background-color', '#E1E8EE');
        });
    }

    switchToPlanCreate() {
        this.chooseTemplateBlock.nativeElement.style.display = 'none';
        this.setupBlock.nativeElement.style.display = 'block';
        this.isTemplateBlockActive = false;
        if (!this.parent.renderForSignup)
            this.parent.setTransparentPopupStyle();
    }

    chooseTemplate(templateType: PlanTemplateType | number, event: Event | undefined = undefined) {
        if ((event?.target as HTMLElement)?.classList.contains('info-toggle-logo'))
            return;

        const template = this.planTemplates.find(x => x.id == templateType);

        if (template) {
            this.newPlan.aTemplateName = template.value;
            switch (templateType) {
                case PlanTemplateType.Blank:
                    this.teamplatelogoImg = "blank";
                    this.chosenTemplateName = this.blankPlanText;
                    break;
                case PlanTemplateType.BikeshopBlank:
                    this.teamplatelogoImg = "bike-shop";
                    this.chosenTemplateName = this.bikeShopPlanText;
                    break;
                case PlanTemplateType.StandardBusinessTemplate:
                    this.teamplatelogoImg = this.isBusinessDoctors ? "business-doctors-standard-business-template" : "standard-business-template";
                    this.chosenTemplateName = this.StandardBusinessTemplate;
                    break;
                case PlanTemplateType.CoffeeShop:
                    this.teamplatelogoImg = "coffee-shop";
                    this.chosenTemplateName = this.coffeeShopPlanText;
                    break;
                case PlanTemplateType.Consulting:
                    this.teamplatelogoImg = "consulting";
                    this.chosenTemplateName = this.consultingPlanText;
                    break;
                case PlanTemplateType.Ecommerce:
                    this.teamplatelogoImg = "e-commerce";
                    this.chosenTemplateName = this.eCommercePlanText;
                    break;
                case PlanTemplateType.FoodVan:
                    this.teamplatelogoImg = "food-van";
                    this.chosenTemplateName = this.foodVanPlanText;
                    break;
                case PlanTemplateType.Gardening:
                    this.teamplatelogoImg = "gardening";
                    this.chosenTemplateName = this.gardeningPlanText;
                    break;
                case PlanTemplateType.Manufacturing:
                    this.teamplatelogoImg = "manufacturing";
                    this.chosenTemplateName = this.manufacturingPlanText;
                    break;
                case PlanTemplateType.Photography:
                    this.teamplatelogoImg = "photography";
                    this.chosenTemplateName = this.photographyPlanText;
                    break;
                case PlanTemplateType.Restaurant:
                    this.teamplatelogoImg = "restaurant";
                    this.chosenTemplateName = this.restaurantPlanText;
                    break;
                case PlanTemplateType.Retail:
                    this.teamplatelogoImg = "retail";
                    this.chosenTemplateName = this.retailPlanText;
                    break;
                case PlanTemplateType.SAAS:
                    this.teamplatelogoImg = "saas";
                    this.chosenTemplateName = this.SAASPlanText;
                    break;
                default:
                    this.teamplatelogoImg = "blank";
                    this.chosenTemplateName = this.newPlan.aTemplateName;
            }

            this.switchToPlanCreate();
        }
    }

    ngOnChanges() {}

    ngOnDestroy(): void {
        dialogCreationActions.setNewPlanDialogOpen(false);

        // Unsubscribe from the redux store
        this.storeUnsubscribe.next();
        this.storeUnsubscribe.complete();
    }

    // Subscribe on the redux store
    private subscribeReduxStore(): void {
        this.appComponent$?.pipe(
            takeUntil(this.storeUnsubscribe))
            ?.subscribe(x => {
                this.appComponent = x;
                if (this.appComponent)
                    this.canUpgrade();
            });

        this.accountAppComponent$?.pipe(
            takeUntil(this.storeUnsubscribe))
            ?.subscribe(x => {
                this.accountAppComponent = x;
                if (this.accountAppComponent)
                    this.canUpgrade();
            });
    }

    toggleBlankPlan(value: boolean) {
        this.isUseTemplate = value;
        this.newPlan.aTemplateName = this.isUseTemplate ? this.standardBusinessTemplate : this.blankText;
    }

    connectToCrunch() {
        // redirect to Crunch SSO page
        localStorage.setItem('isCrunchChosen', 'true');
        this.redirectGlobalService.redirectToIntegrator(IntegrationCompany.Crunch, undefined, this.parent.renderForSignup ? 'signup' : '');
        return;
    }

    createPlan() {

        if(this.newPlan.planName.length == 0 || this.newPlan.planName == '') return;

        if (this.isCrunchChosen) {
            if (this.isCrunchConnectionActive) {
                this.newPlan.aTemplateName = this.crunchPlanText;
            }
            else {
                this.connectToCrunch();
            }
        }

        this.loadingSpinnerService.setLoading(true);

        // Tax system: off or on
        this.newPlan.aVatCalcOption = this.aVatText === 'off' ? 0 : 1;

        // If tax system is off then default taxSystem is vat
        if (!this.isFreeLicense && this.aVatText === 'off')
            this.newPlan.taxSystem = 'vat';
        else
            this.newPlan.taxSystem = this.aVatText; // vat, salesTax, gst

        this.newPlan.currencyId = parseInt(this.currencyString);
        this.newPlan.planStartMonth = parseInt(this.monthString);
        this.newPlan.actualsStartMonth = parseInt(this.actualsMonthString);
        this.newPlan.duration = parseInt(this.durationYear);

        this.newPlan.planStartYear = this.ForecastStartYear;
        this.newPlan.actualsStartYear = this.ActualsStartYear;

        // 1 year before forecast start for all but foundations
        if (this.isPlanStartDateChanger && !this.isFreeLicense) {
            this.newPlan.actualsStartYear = (parseInt(this.ActualsStartYear) - 1).toString();
            this.newPlan.actualsPlanStartDate = this.newPlan.actualsPlanStartDate.subtract(1, 'years');
        }
        

        let planStartDateParam = DateUtils.getStartDateParam(moment(this.newPlan.planStartDate).toDate());
        let actualsStartDateParam = DateUtils.getStartDateParam(moment(this.newPlan.actualsPlanStartDate).toDate());

        this.planService.createPlan(
            this.newPlan.aTemplateName,
            this.newPlan.planName,
            planStartDateParam,
            actualsStartDateParam,
            this.newPlan.duration,
            this.newPlan.yearEndMonth,
            this.newPlan.currencyId,
            this.newPlan.aVatCalcOption,
            this.newPlan.taxSystem,
            this.data,
            this.newPlan.companyId,
            this.isUseCompanyData,
            false
        )
            .then((data) => {
                if (isSuccessResponse(data)) {
                    let plan: BrixxPlan = new BrixxPlan();
                    plan.planguid = data.planGUID;
                    plan.planname = this.newPlan.planName;
                    plan.planlengthName = plan.planlength + "year";
                    plan.isChoosedToKeep = data.isChoosedToKeep;
                    let planJson = JSON.stringify(plan);
                    this.newPlanCreatedCaller.emit(planJson);
                    this.reDirectService.openPlan(plan.planguid)
                        .then((data) => {
                            if (isSuccessResponse(data)) {
                                document.location.assign(this.reDirectService.fullUrl);
                            }
                            else {
                                this.parentCaller.emit(data.errorMessage);
                                this.loadingSpinnerService.setLoading(false);
                            }
                        }, (error) => {
                            this.parentCaller.emit("error");
                            this.loadingSpinnerService.setLoading(false);
                        });

                }
                else {
                    this.parentCaller.emit(data.errorMessage);
                    this.loadingSpinnerService.setLoading(false);
                }

                this.parentCaller.emit("close");

            })
            .catch((error) => {
                this.parentCaller.emit("error");
                this.loadingSpinnerService.setLoading(false);
            });

    }

    onInputTextChange(event: string) {
        if (event == "")
            this.errorMessage = this.planNameFieldMustBeCompleted;
        else
            this.errorMessage = "";
    }

    getPercentFieldDisplayValue(originalVal: string): string {
        return originalVal + '%';
    }

    closeOtherInfoPanels(id: string) {
        if (this.infoPopupItems)
            this.infoPopupItems.forEach(x => {
                if (x.pFieldID !== id)
                    x.close();
            });
    }

    public setNewPlanData() {
        let newPlanData =
        {
            planName: this.newPlan.planName,
            month: this.monthString,
            startYearString: this.actualsStartYearString,
            actualsMonth: this.actualsMonthString,
            actualsStartYearString: this.actualsStartYearString,
            durationYear: this.durationYear,
            yearEndMonth: this.yearEndMonth,
            currencyString: this.currencyString,
            aVatText: this.aVatText,
            importData: this.data
        };

        localStorage.setItem('newPlanData', JSON.stringify(newPlanData));
    }

    brixxChosen() {
        this.isBrixxChosen = true;
        this.isCrunchChosen = this.isXeroChosen = false;
    }

    xeroChosen() {
        this.tryClick();
    }

    crunchChosen() {
        this.crunchConnectionChecked
            .pipe(
                filter(x => x === true),
                take(1)
            )
            .subscribe(_ => {
                if (!this.isCrunchConnectionActive) {
                    this.connectToCrunch();
                } else {
                    this.isCrunchChosen = true;
                    this.isBrixxChosen = this.isXeroChosen = false;
                }
            });
    }

    checkCrunchConnection() {
        return this.crunchService.CheckTokenExpired().then((res: CrunchCheckTokenResult) => {
            this.isCrunchConnectionActive = !res.isExpired;

            if (this.isNewCrunchUserFlow || localStorage.getItem('isCrunchChosen') == 'true')
                this.crunchChosen();

            localStorage.setItem('isCrunchChosen', 'false');

            if (this.isNewCrunchUserFlow)
                localStorage.setItem('isCrunchFlow', 'false');

            this.crunchConnectionChecked.next(true);
        });
    }

    getApp(): CommonApp  {
        if (this.appComponent)
            return this.appComponent;
        else if (this.accountAppComponent)
            return this.accountAppComponent;
        throw new Error('Architecture error.');
    }

    onUpgrade() {
        var authData: AuthData | undefined = this.parent.authData;

        if (!authData)
            return;

        if (this.canUpgrade()) {
            let upgradeWin = <UpgradeWin>this.parent.getDialogCreator().createDialog(UpgradeWin);

            upgradeWin.getAfterInit().subscribe(() => {
                upgradeWin.setAuthData(authData!);
            });

            upgradeWin.setSize(window.innerWidth, window.innerHeight > document.body.scrollHeight ? window.innerHeight : document.body.scrollHeight);
            upgradeWin.show(0, 0);
        } else {
            var trialWin: StartTrialWin = <StartTrialWin>this.getApp()?.createDialog(StartTrialWin);
            trialWin.setSize(DomSmallUtils.width(document.body), DomSmallUtils.height(document.body));
            this.parent.close();
            trialWin.show(0, 0);
        }
    }

    tryClick() {
        this.setNewPlanData();
        document.location.href = `${window.xeroConnectUrl}/?connectMode=newplan&fromAccount=${window.isFromAccount}`;
    }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent): void {
        if (event.key === 'Escape' && (this.isTemplateBlockActive || this.parent.isModal)) {
            this.onClose();
        }
    }

    onClose(): void {
        if (this.isTemplateBlockActive) {
            this.switchToPlanCreate();
        } else {
            this.parent.close();
        }
    }

    notAllAdjustsBlank(): boolean {
        return this.data.salesValue !== 2 || this.data.costsValue !== 2 || this.data.salariesValue !== 2 || this.data.expensesValue !== 2;
    }

    isNotBlank(dataVal: number): boolean {
        return dataVal !== 2;
    }

    private loadTranslations(): void {
        this.translate.get([this.offTaxText, this.VATTaxText, this.salesTaxText, this.GSTTAXText]).subscribe((translations) => {
            const offTaxTextItem = this.onOrOffByDefault.find(item => item.id === 'off');
            if (offTaxTextItem) {
                offTaxTextItem.value = translations[this.offTaxText];
            }

            const VATTaxTextItem = this.onOrOffByDefault.find(item => item.id === 'vat');
            if (VATTaxTextItem) {
                VATTaxTextItem.value = translations[this.VATTaxText];
            }

            const salesTaxTextItem = this.onOrOffByDefault.find(item => item.id === 'salesTax');
            if (salesTaxTextItem) {
                salesTaxTextItem.value = translations[this.salesTaxText];
            }

            const GSTTAXTextItem = this.onOrOffByDefault.find(item => item.id === 'gst');
            if (GSTTAXTextItem) {
                GSTTAXTextItem.value = translations[this.GSTTAXText];
            }

        });
    }
}